import styled, { css } from "styled-components"
import ButtonLink from "../btn-collections/btn-collections.component"

export const VerticalExplorerContainer = styled.div`
  margin-bottom: 20px;
  padding-right: 30px;
  margin-right: 30px;
  margin-top: 15px;
  border-right: 1px solid ${({ theme: { colors } }) => colors.midGrey};

  @media only screen and (max-width: 780px) {
    margin-right: 0;
    padding-right: 0;
    border-right: none;
    margin-top: -40px;
    margin-bottom: ${props => props.isExpanded && !props.isCoursesPage ? "36px" : "0"};
  }
`
export const ExplorePostsTitle = styled.h2`
  ${({ theme: { typography } }) => typography.desktop.h2}

  @media only screen and (max-width: 780px) {
    ${({ theme: { typography } }) => typography.mobile.h2}
    margin-bottom: 20px;
  }
`

export const VerticalH2 = styled.h4`
  ${({ theme: { typography } }) => typography.desktop.h4};
  color: ${({ theme: { colors } }) => colors.black};
  margin-bottom: 12px;

  @media only screen and (max-width: 780px) {
    ${({ theme: { typography } }) => typography.mobile.h4};
    margin-bottom: 20px;
  }
`

const ActiveStyles = css`
  border-left: 5px solid;
  border-color: ${({ theme: { colors } }) => colors.accentBlue};
  color: ${({ theme: { colors } }) => colors.accentBlue};
  margin-left: 5px;
  padding-left: 13px;
`

const getActiveState = ({ isActive }) => {
  if (isActive) return ActiveStyles
}

// Show all post
export const VerticalLink = styled.h6`
${({ theme: { typography } }) => typography.desktop.h6};
  /*${({ theme: { typography } }) => typography.desktop.link};*/
  color: ${({ theme: { colors } }) => colors.black};
  
  border-left: 5px solid #fff;
  padding: 5px 0;
  padding-left: 18px;

  :before {
    content: none;
  }

  :after {
    content: none;
  }

  & a {
    text-decoration: none;
  }

  

  @media only screen and (max-width: 780px) {
    padding: 0;
    padding-left: 18px;
    line-height: 36px;
    margin-left: 0;
  }

  ${getActiveState}
`

export const VerticalH3 = styled.h5`
  ${({ theme: { typography } }) => typography.desktop.h5};
  color: ${({ theme: { colors } }) => colors.black};
  margin-top: 20px;
  margin-bottom:  ${props => props.isCoursesPage ? "15px" : "20px"};
  padding-bottom: 2px;
  border-bottom: ${props => props.isTopicHovered || props.isFormatHovered ? "2px solid black" : "2px solid white"};
  border-bottom-right-radius: ${props => props.isTopicHovered || props.isFormatHovered ? "1px" : null};
  border-bottom-left-radius: ${props => props.isTopicHovered || props.isFormatHovered ? "1px" : null};
  border-bottom: ${props => props.isCoursesPage ? "none" : "initial"};

  @media only screen and (max-width: 780px) {
    ${({ theme: { typography } }) => typography.mobile.h5};
  }
`

export const VerticalTopicLink = styled.h6`
  ${({ theme: { typography } }) => typography.desktop.h6};
  color: ${({ theme: { colors } }) => colors.black};
  padding: 12px 0 12px 18px;
  border-left: 5px solid #fff;
  text-decoration: none;
  border-left: ${props => props.isCoursesPage && !props.isSmallScreen ? "5px solid rgb(246, 246, 251)" : "5px solid #fff"};

  a {
    text-decoration: none;
    display: inline-block;
    position: relative;
    z-index: 1;
    width: 100%;
  }

  :hover {
    background-color: ${(props) => props.isCoursesPage ? "white" : "rgb(246, 246, 251)"};
    border-radius: 5px;
    width: 100%;
  }

  ${getActiveState}

  @media only screen and (max-width: 780px) {
    
    a {
      width: 100%;
    }
    :hover {
      background-color: ${(props) => props.isCoursesPage && props.isSmallScreen ? "rgb(246, 246, 251)" : "#fff"};

    }
  }
`

export const FormatContainer = styled.div`
  border-top: 1px solid ${({ theme: { colors } }) => colors.midGrey};
  border-bottom: 1px solid ${({ theme: { colors } }) => colors.midGrey};
  padding-bottom: 15px;
`

export const CategoryContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  padding-top: 5px;
  margin-bottom: -15px;
`

export const ExpandFiltersButton = styled(ButtonLink)`
  width: 100%;
  margin-bottom: 40px;
  display: flex;
  flex-direction: row;

  & svg {

  }
`
export const ChevronContainer = styled.div`
  padding: 0;
`